import { useEffect, useState } from 'react';
import useSWR from 'swr';
import urlcat from 'urlcat';
import getAuthClient from 'Tasking_Helpers/getAuthClient';

const requestPath = 'v1/thrive/progress/:userId';

const retrieveApiProgress = async (url) => {
  const authorizedApiClient = await getAuthClient();

  if (authorizedApiClient) {
    return await authorizedApiClient.get(url);
  }
};

function useThriveProgress() {
  const [isPending, setIsPending] = useState(true);
  const [progress, setProgress] = useState();
  const [url, setUrl] = useState();

  const {
    data: response,
    error,
    mutate,
  } = useSWR(() => url, retrieveApiProgress, {
    revalidateOnFocus: false,
  });

  const getThriveProgress = (userId) => {
    setUrl(urlcat(process.env.API_BASE_URL, requestPath, { userId }));
    mutate(response);
  };

  useEffect(() => {
    if (response) {
      setProgress(response.data);
    }

    setIsPending(!response && !error);
  }, [response, error]);

  return { progress, error, isPending, getThriveProgress };
}

export default useThriveProgress;
